import MorableButton from "@components/moreable_button";
import AnimateHeight from "@components/react-animate-height";
import { useTranslation } from "react-i18next";
import { Tree } from "antd";
import { useState, useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import { PiSpinnerGap } from "react-icons/pi";

const { TreeNode } = Tree;

const SportsBox = ({
  data,
  handleFilterSelection,
  isFiltersLoadingInline,
  filters,
}) => {
  const [checked, setChecked] = useState([]);
  const [isSeeMore, setIsSeeMore] = useState(false);

  const { t, i18n } = useTranslation("common");
  const isEn = i18n.language === "en";

  useEffect(() => {
    const selectedFilters = [
      // ...(filters.sport || []),
      ...(filters.sub_sport || []),
    ];
    setChecked(selectedFilters);
    setIsSeeMore(selectedFilters?.length > 0);
  }, [filters.sub_sport]);

  const onCheck = (checkedKeys, { node, checked: isChecked }) => {
    const type = node?.data?.type || "";
    const alias = node?.data?.alias || "";

    if (isChecked) {
      setChecked((prev) => [...prev, alias]);
    } else {
      setChecked((prev) => prev.filter((key) => key !== alias));
    }

    handleFilterSelection(type, alias, isChecked);
  };

  const onSelect = (selectedKeys, info) => {
    const type = info?.node?.data?.type || "";
    const alias = info?.node?.data?.alias || "";
    const isChecked = !checked.includes(alias);

    if (isChecked) {
      setChecked((prev) => [...prev, alias]);
    } else {
      setChecked((prev) => prev.filter((key) => key !== alias));
    }

    handleFilterSelection(type, alias, isChecked);
  };

  const renderTreeNodes = (data, type) =>
    data?.map((item) => (
      <TreeNode
        title={
          <div className="flex justify-between items-center">
            <p className="text-base">
              {isEn
                ? item?.title_en ?? item?.title_de
                : item?.title_de ?? item?.title_en}
              {item.count && ` (${item.count})`}
            </p>
          </div>
        }
        key={item.alias}
        data={{ alias: item.alias, type: type }}
      >
        {/* {item?.sub_categories &&
          renderTreeNodes(item?.sub_categories, "sub_sport")} */}
      </TreeNode>
    ));

  const renderTree = () => (
    <Tree
      checkable
      onCheck={onCheck}
      onSelect={onSelect}
      checkedKeys={checked?.map((filter) => filter)}
      checkStrictly
      switcherIcon={
        isFiltersLoadingInline ? (
          <PiSpinnerGap className="!text-base !-mb-1 animate-spin" />
        ) : (
          <DownOutlined />
        )
      }
      disabled={isFiltersLoadingInline}
      className="[&_.ant-tree-switcher]:!hidden !z-10" // !-ml-1
    >
      {/* {renderTreeNodes(data, "sport")} */}
      {renderTreeNodes(data?.[0]?.sub_categories, "sub_sport")}
    </Tree>
  );

  return (
    <article className="w-full border-t-green border-t-4 py-3 lg:px-5 px-4 border rounded-2xl">
      <h3 className="font-bold text-lg mb-[10px]">
        {t("search.filter_Kategorie")}
      </h3>

      <div className="w-full search_tree">
        {data?.[0]?.sub_categories?.length > 8 ? (
          <div>
            <AnimateHeight
              duration={500}
              height={isSeeMore ? "auto" : 280}
              className="[&_.g-container]:!h-[35px] [&_.g-container]:!z-30"
            >
              {renderTree()}
            </AnimateHeight>

            <MorableButton
              underline={true}
              isOpen={isSeeMore}
              onClick={() => setIsSeeMore((prev) => !prev)}
              allNumber={data?.[0]?.sub_categories?.length}
            />
          </div>
        ) : (
          renderTree()
        )}
      </div>
    </article>
  );
};

export default SportsBox;
